import { LanguageConst } from '../resources/languageconst';
import { CategoryDto } from '../../core/dto/categories/categorydto';

export interface UserContext
{
    getAccessToken(): string;
    getRefreshToken(): string;
    getMsisdn(): string;
    getDeviceId(): string;
    getExpiry(): number;
    getIsLoggedIn(): boolean;
    getIsRememberMe(): boolean;
    getIsNewUser(): boolean;
    getPackName():string;
    getLanguage(): LanguageConst;
    getUsername(): string;
    getPassword(): string;
    getServiceType(): string;
    getSecToken(): string;
    getCountryCode(): string;
    getCategoryInfo(): CategoryDto;
    getTermsAndConditionsRemember(): boolean;
    getMsisdnB(): string;
    getPackName(): string;
    getPackDisplayName(): string;
    getChannelId(): string;
    getExpiryTimeStamp(): number;
     
    setPackName(packName: string): void;
    setPackDisplayName(displyPackName: string): void;
    setUserName(userName: string): void;
    setMsisdn(msisdn: string): void;
    setPackName(packName: string):void;
    setChannelId(channelId: string): void;
    setIsnewUser(isNewUser: boolean):void;
    setMsisdnB(msisdn: string): void;
    setCountryCode(countryCode: string): void;
    setPassword(password: string): void;
    setAccessToken(accessToken: string): void;
    setRefreshToken(refreshToken: string): void;
    setDeviceId(deviceId : string): void;
    setServiceType(type: string): void;
    setSecToken(token: string): void;
    getCountryCode(): string;
    setExpiry(expiry : number): void;
    setExpiryTimeStamp(timestamp: number): void;
    setIsLoggedIn(loggedIn: boolean): void;
    setIsRememberMe(rememberMe: boolean): void;
    setIsTermsAndConditionsRemember(rememberMe: boolean): void;
    setCategoryInfo(categoryInfo: CategoryDto): void;
    setLanguage(languageConst: LanguageConst): void;
}

export class UserContextImpl implements UserContext
{
    
    private msisdn: string = "";
    private password: string= "";
    private secToken: string;
    private serviceType: string = "";
    private isRememberMe: boolean;
    private accessToken: string;
    private refreshToken: string;
    private msisdnB: string;
    private deviceId: string;
    private expiry: number;
    private userName: string;
    private counterCode: string;
    private packName: string;
    private channelId: string = "";
    private displyPackName: string;
    private isLoggedIn: boolean = false;
    private categoryInfo: CategoryDto;
    private expiryTimeStamp: number;
   
    private isNewUser :boolean = false;
    private isTermsAndConditionsRemember: boolean = false;
    private language: LanguageConst = LanguageConst.FRENCH;

    getExpiryTimeStamp(): number {
        return this.expiryTimeStamp;
    }
    setExpiryTimeStamp(timestamp: number): void {
       this.expiryTimeStamp = timestamp;
    }
  
    setUserName(userName: string): void {
      this.userName = userName;
    }
    getPackDisplayName(): string {
        return this.displyPackName;
    }
  
    setPackDisplayName(displyPackName: string): void {
        this.displyPackName = displyPackName;
    }
    getServiceType(): string {
       return this.serviceType;
    }
    getSecToken(): string {
       return this.secToken;
    }

    setServiceType(type: string): void {
        this.serviceType = type;
    }
    setSecToken(token: string): void {
      this.secToken = token;
    }
    getCategoryInfo(): CategoryDto 
    {
        return this.categoryInfo;
    }
     getIsNewUser():boolean{
         return this.isNewUser;
     }
     setIsnewUser(isNewUser:boolean):void{
         this.isNewUser = isNewUser;
     }
     getPackName():string
     {
         return this.packName;
     }
     setPackName(packName:string):void
     {
         this.packName = packName;
     }
    setCategoryInfo(categoryInfo: CategoryDto): void 
    {
        this.categoryInfo =categoryInfo;
    }

    getTermsAndConditionsRemember(): boolean {
        return this.isTermsAndConditionsRemember;
    }

    setIsTermsAndConditionsRemember(rememberMe: boolean): void 
    {
        this.isTermsAndConditionsRemember = rememberMe;
    }

    getDeviceId(): string 
    {
        return this.deviceId;
    }

    getAccessToken(): string {
       return this.accessToken;
    }
    getRefreshToken(): string {
        return this.refreshToken;
    }
    getMsisdn(): string {
        return this.msisdn;
    }
    getIsLoggedIn(): boolean {
        return this.isLoggedIn;
    }
    getExpiry(): number {
        return this.expiry;
    }
    getLanguage(): LanguageConst {
        return this.language;
    }

    getUsername(): string 
    {
        return this.userName;
    }

    getIsRememberMe(): boolean {
        return this.isRememberMe;
    }

    getPassword(): string {
       return this.password;
    }

    setPassword(password: string): void {
       this.password = password;
    }

    setIsRememberMe(rememberMe: boolean): void 
    {
        this.isRememberMe = rememberMe;
    }

    setMsisdn(msisdn: string)
    {
        this.msisdn = msisdn;
    }

    setDeviceId(deviceId: string)
    {
        this.deviceId = deviceId;
    }

    setAccessToken(accessToken: string)
    {
        this.accessToken = accessToken;
    }

    setRefreshToken(refreshToken: string)
    {
        this.refreshToken = refreshToken;
    }
    setExpiry(expiry: number)
    {
        this.expiry = expiry;
    }

    setIsLoggedIn(loggedIn: boolean)
    {
        this.isLoggedIn = loggedIn;
    }

    setLanguage(languageConst: LanguageConst)
    {
        this.language = languageConst;
    }

    getCountryCode(): string {
        return this.counterCode;
    }
    setCountryCode(countryCode: string): void {
       this.counterCode = countryCode;
    }

    getMsisdnB(): string {
       return this.msisdnB;
    }
    setMsisdnB(msisdn: string): void {
        this.msisdnB = msisdn;
    }
    getChannelId(): string {
        return this.channelId;
    }
    setChannelId(channelId: string): void
     {
         console.log("--------tigerset"+channelId);
      this.channelId = channelId;
    }
    fromJson(userJsonData: any)
    {
        this.setMsisdn(userJsonData.msisdn);
        this.setUserName(userJsonData.userName);
        this.setChannelId(userJsonData.channelId);
        this.setMsisdnB(userJsonData.msisdnB);
        this.setCountryCode(userJsonData.countryCode);
        this.setPassword(userJsonData.password);
        this.setAccessToken(userJsonData.accessToken);
        this.setExpiry(userJsonData.expiry);
        this.setRefreshToken(userJsonData.refreshToken);
        this.setIsLoggedIn(userJsonData.isLoggedIn);
        this.setIsRememberMe(userJsonData.isRememberMe);
        this.setIsTermsAndConditionsRemember(userJsonData.isTermsAndConditionsRemember);
        this.setLanguage(userJsonData.language);
        this.setSecToken(userJsonData.secToken);
        this.setPackName(userJsonData.packName);
        this.setPackDisplayName(userJsonData.displyPackName);
        this.setCategoryInfo(userJsonData.categoryInfo);
        this.setExpiryTimeStamp(userJsonData.expiryTimeStamp);
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/utils/usercontext/usercontext.ts